import { styled } from "@mui/material/styles";
import { FormattedMessage } from "react-intl";
import { Route, Routes } from "react-router-dom";

import { EntryContainer } from "@/shared/containers/EntryContainer/EntryContainer";

import { EAgriImportNotification } from "./EAgriImportNotification";
import { FarmImport } from "./FarmImport";
import { NewAccount } from "./NewAccount";
import { SignupToLogin } from "./SignupToLogin";

const Signup = (): React.ReactElement => {
  const newAccount = (
    <AccountStep>
      <NewAccount />
      <SignupToLogin />
    </AccountStep>
  );

  const importInProgress = (
    <EAgriImportNotification
      buttonCopy={<FormattedMessage id="FarmImport.notification.button" />}
      heading={<FormattedMessage id="FarmImport.notification.heading" />}
      description={
        <FormattedMessage
          id="FarmImport.notification.description"
          values={{
            str: ((chunks: React.ReactNode) => (
              <BoldText>{chunks}</BoldText>
            )) as unknown as React.ReactNode,
          }}
        />
      }
    />
  );

  const importFailed = (
    <EAgriImportNotification
      heading={<FormattedMessage id="FarmImport.notification.error.heading" />}
      type="error"
      buttonCopy={
        <FormattedMessage id="FarmImport.notification.error.button" />
      }
      description={
        <FormattedMessage id="FarmImport.notification.error.description" />
      }
    />
  );

  return (
    <EntryContainer>
      <Routes>
        <Route element={newAccount} path="" />
        <Route element={<FarmImport />} path="import" />
        <Route element={importInProgress} path="import-in-progress" />
        <Route element={importFailed} path="import-failed" />
      </Routes>
    </EntryContainer>
  );
};

const AccountStep = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: theme.spacing(2),
  justifyContent: "center",
}));

const BoldText = styled("span")({
  fontWeight: "bold",
});

export { Signup };
